var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5693 2.23706L16.6646 15.9355C16.4453 16.9021 15.874 17.1427 15.0621 16.6876L10.6359 13.4261L8.50056 15.4804C8.26406 15.7169 8.06674 15.9142 7.61093 15.9142L7.92924 11.4069L16.1318 3.995C16.4886 3.67737 16.0541 3.50068 15.5777 3.819L5.43706 10.2045L1.07143 8.83775C0.121994 8.54143 0.104806 7.88831 1.26943 7.4325L18.3449 0.85381C19.1355 0.557497 19.8271 1.02912 19.5693 2.23706Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramm);
export default __webpack_public_path__ + "static/media/telegramm.c6fdf3d6d7756098a6fca9735c9ebd0b.svg";
export { ForwardRef as ReactComponent };